<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Task Title</th>
          <th>Full Description</th>
          <th>Assigned To</th>
          <th>Report To</th>
          <th>Created By</th>
          <th>Organizations Activity</th>
          <th>Client</th>
          <th>Project</th>
          <th>Project Activity</th>
          <th>Participants</th>
          <th>Start Date & Time</th>
          <th>End Date & Time</th>
          <th>Type</th>
          <th>Status</th>
          <th>Attachment</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
            <td>{{ item.short_description }}</td>
            <td>{{ item.full_description }}</td>
            <td>{{ item.assigned_to }}</td>
            <td>{{ item.report_to }}</td>
            <td>{{ item.user_name }}</td>
            <td>{{ item.activity_setup_id }}</td>
            <td>{{ item.client_id }}</td>
            <td>{{ item.project_id }}</td>
            <td>{{ item.project_activity_id }}</td>
            <td>{{ item.participant_id }}</td>
            <td>{{ item.format_start_time }}</td>
            <td>{{ item.format_end_time }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.status }}</td>
            <td></td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>

import {useStore} from "vuex";

const props  = defineProps({
  tableItems     : Object,
  getMyLeaveList : Function
});
const store = useStore()
</script>
